import React, { useState } from 'react';
import Select from 'react-select';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import ImageModalEquip from './Modal/ImageModalProd';
import ImageModalDownloadable from './Modal/ImageModalDownloadble';
import ImageModalGallery from './Modal/ImageModalGallery';


const ImageUploader = ({ onSelectImage }) => (
    <button onClick={() => alert("Open image modal or uploader here")}>
        Upload Image
    </button>
);

const EquipmentsModal = ({ isOpen, setIsOpen }) => {
    // State for form fields
    const [formData, setFormData] = useState({
        image: [],
        gallery: [],
        title: '',
        originalPrice: '',
        discountPrice: '',
        product_type: { value: 'Simple Product', label: 'Simple Product' },
        category: null,
        total: '',
        stock: '',
        status: null,
        typeofsimple: "",
        short_description: "",
        description: "",
        grouped_products: [],
        product_url: "",
        button_text: "",
        stock: "",
        download_limit: "",
        download_expiry: ""
    });
    const [availableSizes] = useState(["XS", "S", "M", "L", "XL", "XXL"]);
    const [selectedSizes, setSelectedSizes] = useState([]);
    const [variationsAccordion, setVariationsAccordion] = useState([]);
    const [showVariations, setShowVariations] = useState(false);
    const urlmain = process.env.REACT_APP_LINK

    const [activeIndex, setActiveIndex] = useState(null);
    const toggleAccordion = (index) => {
        setActiveIndex(prevIndex => (prevIndex === index ? null : index));
    };

    const updateVariation = (index, field, value) => {
        setVariations(prev => {
            const updated = [...prev];
            updated[index] = { ...updated[index], [field]: value };
            return updated;
        });
    };



    const attributeOptions = [
        { value: 'size', label: 'Size' },
        { value: 'weight', label: 'Weight' },
        { value: 'length', label: 'Length' },
        { value: 'thickness', label: 'Thickness' },
        // Add more as needed
    ];

    const sizeOptions = [
        { value: 'S', label: 'S' },
        { value: 'M', label: 'M' },
        { value: 'L', label: 'L' },
        { value: 'XL', label: 'XL' },
        { value: 'XXL', label: 'XXL' },
    ];

    const WeightOptions = [
        { value: '30 kg', label: '30 kg' },
        { value: '50 kg', label: '50 kg' },

    ]


    const [showImageModal, setShowImageModal] = useState(false);
    const [images, setImages] = useState([]);

    const [showImageModalGallery, setShowImageModalGallery] = useState(false);
    const [imagesGallery, setImagesGallery] = useState([]);


    const [isUploadModalOpen, setUploadModalOpen] = useState(false);


    const [variations, setVariations] = useState([]);
    const [variationDetails, setVariationDetails] = useState({});
    const [selectedImageVar, setSelectedImageVar] = useState(null); // For main product image
    const [showModalVar, setShowModalVar] = useState(false);
    const [showModalVar1, setShowModalVar1] = useState(false);
    const [imagesVar, setImagesVar] = useState([]);
    const [variationImages, setVariationImages] = useState({}); // Track selected images for each variation
    const [currentVariationId, setCurrentVariationId] = useState(null);
    const [variationGalleryImages, setVariationGalleryImages] = useState({});

    const handleOpenModalVar = (variationId) => {
        setCurrentVariationId(variationId); // Set the variation ID
        setShowModalVar(true); // Open the modal
    };

    const handleCloseModalVar = () => {
        setShowModalVar(false);
    };


    const handleRemoveVariationImage = (variationId) => {
        setVariationImages((prevImages) => {
            const updatedImages = { ...prevImages };
            delete updatedImages[variationId];
            return updatedImages;
        });
    };

    // const updateTypeofSimple = (key, isChecked) => {
    //     const currentTypes = formData.typeofsimple.split(',').filter(Boolean);
    //     let updatedTypes = isChecked
    //         ? [...new Set([...currentTypes, key])]
    //         : currentTypes.filter(type => type !== key);

    //     setFormData((prev) => ({
    //         ...prev,
    //         typeofsimple: updatedTypes.join(',')
    //     }));
    // };

    const updateTypeofSimple = (key, isChecked) => {
        let updatedTypes = formData.typeofsimple.split(',').filter(Boolean);

        if (key === 'virtual' && isChecked) {
            // Add 'virtual', remove 'downloadable'
            updatedTypes = ['virtual'];
        } else if (key === 'downloadable' && isChecked) {
            // Add 'downloadable', remove 'virtual'
            updatedTypes = ['downloadable'];
        } else {
            // Remove the key from selection
            updatedTypes = updatedTypes.filter(type => type !== key);
        }

        setFormData((prev) => ({
            ...prev,
            typeofsimple: updatedTypes.join(',')
        }));
    };


    const statusOptions = [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' },
    ];

    const categoryOptions = [
        { value: 'electronics', label: 'Electronics' },
        { value: 'fashion', label: 'Fashion' },
        { value: 'home', label: 'Home' },
        { value: 'books', label: 'Books' },
    ];

    const ProductOptions = [
        { value: 'Simple Product', label: 'Simple Product' },
        { value: 'Grouped Product', label: 'Grouped Product' },
        { value: 'External/Affiliate Product', label: 'External/Affiliate Product' },
        { value: 'Variable Product', label: 'Variable Product' },
    ];

    const StockOptions = [
        { value: 'In stock', label: 'In stock' },
        { value: 'Out of stock', label: 'Out of stock' },
        { value: 'On backorder', label: 'On backorder' },
    ];

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData((prev) => ({ ...prev, [id]: value }));
    };

    const handleSelectChange = (selectedOption, { name }) => {
        setFormData((prev) => ({ ...prev, [name]: selectedOption }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Form Submitted:', formData);
        setIsOpen(false); // Close modal after submit
    };



    if (!isOpen) return null;

    return (
        <>
            <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
                <div
                    className="custom-modal-content"
                    onClick={(e) => e.stopPropagation()} // Prevent closing on content click
                >
                    <h2 className="oms-modal-title">Product</h2>
                    <form className="oms-modal-form" onSubmit={handleSubmit}>
                        <div className="oms-form-group">
                            <label htmlFor="category" className="oms-form-label">
                                Product Type
                            </label>
                            <Select
                                options={ProductOptions}
                                placeholder="Select Product Type"
                                name="product_type"
                                value={formData.product_type}
                                onChange={handleSelectChange}
                            />
                        </div>
                        {/* Image Upload */}

                        {
                            formData.product_type.value === "Simple Product" && (
                                <div className="oms-form-group">
                                    <label className="oms-form-label">Choose Type</label>
                                    <div className="oms-checkbox-group">
                                        <div className="oms-checkbox-item">
                                            <input
                                                type="checkbox"
                                                id="virtual"
                                                checked={formData.typeofsimple.includes("virtual")}
                                                onChange={(e) => updateTypeofSimple("virtual", e.target.checked)}
                                            />
                                            <label htmlFor="virtual">Virtual</label>
                                        </div>
                                        <div className="oms-checkbox-item">
                                            <input
                                                type="checkbox"
                                                id="downloadable"
                                                checked={formData.typeofsimple.includes("downloadable")}
                                                onChange={(e) => updateTypeofSimple("downloadable", e.target.checked)}
                                            />

                                            <label htmlFor="downloadable">Downloadable</label>
                                        </div>
                                    </div>
                                </div>
                            )
                        }


                        {/* Title */}
                        <div className="oms-form-group">
                            <label htmlFor="title" className="oms-form-label">
                                Name
                            </label>
                            <input
                                type="text"
                                id="title"
                                placeholder="Enter title"
                                value={formData.title}
                                onChange={handleChange}
                            />
                        </div>


                        <div className="oms-form-group">
                            <label htmlFor="description" className="oms-form-label">
                                Description
                            </label>
                            <ReactQuill
                                theme="snow"
                                value={formData.description}
                                onChange={(value) =>
                                    setFormData((prev) => ({ ...prev, description: value }))
                                }
                                style={{backgroundColor:"#fefffc"}}
                                placeholder="Enter Description"
                            />
                        </div>

                        {/* Product Image Upload */}
                        <div className="oms-form-group">
                            <label className="oms-form-label">Product Image</label>

                            {/* Button to open image modal */}
                            <button
                                type="button"
                                className="image-upload-btn"
                                onClick={() => setShowImageModal(true)}
                            >
                                Choose Image
                            </button>


                            {/* Preview selected image */}
                            {formData.image.length > 0 && (
                                <div className="selected-image-preview">
                                    <img
                                        src={formData.image[0]?.url ? `https://100billionoms.top${formData.image[0].url}` : formData.image[0]}
                                        alt="Selected"
                                        style={{ width: "100px", height: "100px", objectFit: "cover", marginTop: "10px", border: "1px solid #ccc" }}
                                    />
                                    <button
                                        onClick={() => setFormData((prev) => ({ ...prev, image: [] }))}
                                        style={{ display: "block", marginTop: "5px", color: "red" }}
                                    >
                                        Remove
                                    </button>
                                </div>
                            )}
                        </div>

                        <ImageModalEquip
                            show={showImageModal}
                            handleClose={() => setShowImageModal(false)}
                            images={images}
                            onImageSelect={(img) =>
                                setFormData((prev) => ({ ...prev, image: [img] }))
                            }
                            multiple={false}
                            setImages={setImages}
                        />

                        <div className="oms-form-group">
                            <label className="oms-form-label">Product Gallery</label>
                            <button
                                type="button"
                                className="image-upload-btn"
                                onClick={() => setShowImageModal(true)}
                            >
                                Add Gallery Images
                            </button>

                            {/* Preview selected gallery images */}
                            <div className="gallery-preview">
                                {formData.gallery.map((img, index) => (
                                    <div key={index} style={{ display: 'inline-block', marginRight: 10, position: 'relative' }}>
                                        <img
                                            src={img?.url ? `https://100billionoms.top${img.url}` : img}
                                            alt="gallery"
                                            style={{ width: "80px", height: "80px", objectFit: "cover", border: "1px solid #ccc" }}
                                        />
                                        <button
                                            type="button"
                                            onClick={() => {
                                                setFormData(prev => ({
                                                    ...prev,
                                                    gallery: prev.gallery.filter((_, i) => i !== index)
                                                }));
                                            }}
                                            style={{ position: 'absolute', top: 0, right: 0, background: 'red', color: '#fff', border: 'none' }}
                                        >
                                            ×
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <ImageModalGallery
                            show={showImageModal}
                            handleClose={() => setShowImageModal(false)}
                            images={images}
                            multiple={true} // ⬅️ set to true for gallery
                            setImages={setImages}
                            onImageSelect={(imgs) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    gallery: Array.isArray(imgs) ? [...prev.gallery, ...imgs] : [...prev.gallery, imgs]
                                }));
                            }}
                        />


                        {
                            (formData.typeofsimple === "downloadable" && formData.product_type.value === "Simple Product") ?
                                <div className="oms-form-group">
                                    <label htmlFor="status" className="oms-form-label">
                                        Downloadable files
                                    </label>
                                    <DownloadableFiles />
                                </div> : null
                        }
                        {
                            (formData.typeofsimple === "downloadable" && formData.product_type.value === "Simple Product") ?
                                <>
                                    <div className="oms-form-group">
                                        <label htmlFor="originalPrice" className="oms-form-label">
                                            Download Limit
                                        </label>
                                        <input
                                            type="number"
                                            id="originalPrice"
                                            placeholder="Unlimited"
                                            value={formData.download_limit}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="oms-form-group">
                                        <label htmlFor="originalPrice" className="oms-form-label">
                                            Download Expiry
                                        </label>
                                        <input
                                            type="number"
                                            id="originalPrice"
                                            placeholder="Enter the number of days before a download link expires, or leave blank."
                                            value={formData.download_expiry}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </>
                                : null
                        }


                        <div className="oms-form-group">
                            <label htmlFor="description" className="oms-form-label">
                                Short  Description
                            </label>
                            <ReactQuill
                                theme="snow"
                                value={formData.short_description}
                                onChange={(value) =>
                                    setFormData((prev) => ({ ...prev, short_description: value }))
                                }
                                placeholder="Enter Short Description"
                            />
                        </div>

                        {
                            formData.product_type.value === "Grouped Product" ?
                                <div className="oms-form-group">
                                    <label htmlFor="originalPrice" className="oms-form-label">
                                        Grouped Products
                                    </label>
                                    <input
                                        type="text"
                                        id="originalPrice"
                                        placeholder="Enter Product Name"
                                        value={formData.grouped_products}
                                        onChange={handleChange}
                                    />
                                </div> : null
                        }
                        {/* Original Price */}
                        <div className="oms-form-group">
                            <label htmlFor="originalPrice" className="oms-form-label">
                                Original Price
                            </label>
                            <input
                                type="number"
                                id="originalPrice"
                                placeholder="Enter original price"
                                value={formData.originalPrice}
                                onChange={handleChange}
                            />
                        </div>

                        {/* Discount Price */}
                        <div className="oms-form-group">
                            <label htmlFor="discountPrice" className="oms-form-label">
                                Sale Price
                            </label>
                            <input
                                type="number"
                                id="discountPrice"
                                placeholder="Enter Sale price"
                                value={formData.discountPrice}
                                onChange={handleChange}
                            />
                        </div>

                        {
                            formData.product_type.value === "External/Affiliate Product" ?
                                <>
                                    <div className="oms-form-group">
                                        <label htmlFor="discountPrice" className="oms-form-label">
                                            Product Url
                                        </label>
                                        <input
                                            type="text"
                                            id="product_url"
                                            placeholder="Enter Product Url"
                                            value={formData.product_url}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="oms-form-group">
                                        <label htmlFor="discountPrice" className="oms-form-label">
                                            Button Text
                                        </label>
                                        <input
                                            type="text"
                                            id="button_text"
                                            placeholder="Enter Button Text"
                                            value={formData.button_text}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </> : null
                        }

                        {formData.product_type.value === "Variable Product" && (
                            <div className="oms-form-group">
                                <label className="oms-form-label">Select Attributes</label>
                                <Select
                                    isMulti
                                    options={attributeOptions}
                                    placeholder="Choose attributes"
                                    name="attributes"
                                    value={formData.attributes || []}
                                    onChange={(selected) =>
                                        setFormData((prev) => ({ ...prev, attributes: selected }))
                                    }
                                />
                            </div>
                        )}

                        {formData.product_type.value === "Variable Product" &&
                            formData.attributes?.some(attr => attr.value === 'size') && (
                                <div className="oms-form-group">
                                    <label className="oms-form-label">Select Sizes</label>
                                    <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
                                        <button
                                            type="button"
                                            onClick={() => setSelectedSizes(sizeOptions.map(opt => opt.value))}
                                        >
                                            Select All
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => setSelectedSizes([])}
                                        >
                                            Clear
                                        </button>
                                    </div>
                                    <Select
                                        isMulti
                                        options={sizeOptions}
                                        placeholder="Choose sizes"
                                        value={sizeOptions.filter(opt => selectedSizes.includes(opt.value))}
                                        onChange={(selected) =>
                                            setSelectedSizes(selected.map(opt => opt.value))
                                        }
                                    />
                                </div>
                            )}

                        {formData.product_type.value === "Variable Product" && selectedSizes.length > 0 && (
                            <div className="oms-form-group">
                                <button
                                    type="button"
                                    onClick={() => {
                                        const newVariations = selectedSizes.map(size => ({
                                            name: `Size: ${size}`,
                                            size,
                                            price: '',
                                            salePrice: '',
                                            stock: '',
                                            stockStatus: null,
                                            image: null,
                                            gallery: [],
                                        }));
                                        setVariationsAccordion(newVariations); // ✅ Use this
                                        setShowVariations(true);
                                    }}
                                >
                                    {variationsAccordion.length > 0 ? "Regenerate Variations" : "Generate Variations"}
                                </button>
                            </div>
                        )}





                        {showVariations && (
                            <div className="variations-accordion">
                                <h4 style={{ marginTop: "15px" }}>Generated Variations</h4>

                                {variationsAccordion.map((variation, index) => (
                                    <div
                                        key={index}
                                        style={{
                                            border: "1px solid #ccc",
                                            borderRadius: "8px",
                                            marginBottom: "15px",
                                            background: "#f9f9f9",
                                            overflow: "hidden",
                                        }}
                                    >
                                        <div
                                            style={{
                                                padding: "10px 15px",
                                                background: "#ddd",
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => toggleAccordion(index)}
                                        >
                                            <h5 style={{ margin: 0 }}>{variation.name}</h5>
                                            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                                <span style={{ fontSize: "18px", cursor: "pointer" }}>
                                                    {activeIndex === index ? <i class="fa-solid fa-minus"></i> : <i class="fa-solid fa-plus"></i>}
                                                </span>
                                                <button
                                                    type="button"
                                                    onClick={(e) => {
                                                        e.stopPropagation(); // prevent accordion toggle
                                                        const updated = [...variationsAccordion];
                                                        updated.splice(index, 1);
                                                        setVariationsAccordion(updated);
                                                        if (activeIndex === index) setActiveIndex(null);
                                                    }}
                                                    style={{
                                                        background: "red",
                                                        color: "#fff",
                                                        border: "none",
                                                        borderRadius: "4px",
                                                        padding: "2px 5px",
                                                        fontSize: "12px",
                                                        cursor: "pointer"
                                                    }}
                                                >
                                                    <i class="fa-solid fa-trash"></i>
                                                </button>
                                            </div>

                                        </div>

                                        {activeIndex === index && (
                                            <div style={{ padding: "15px", background: "#fff" }}>
                                                <div className="oms-form-group">
                                                    <label>Price</label>
                                                    <input
                                                        type="number"
                                                        value={variation.price}
                                                        onChange={(e) => {
                                                            const updated = [...variationsAccordion];
                                                            updated[index].price = e.target.value;
                                                            setVariationsAccordion(updated);
                                                        }}
                                                    />
                                                </div>

                                                <div className="oms-form-group">
                                                    <label>Sale Price</label>
                                                    <input
                                                        type="number"
                                                        value={variation.salePrice}
                                                        onChange={(e) => {
                                                            const updated = [...variationsAccordion];
                                                            updated[index].salePrice = e.target.value;
                                                            setVariationsAccordion(updated);
                                                        }}
                                                    />
                                                </div>

                                                <div className="oms-form-group">
                                                    <label>Stock</label>
                                                    <input
                                                        type="number"
                                                        value={variation.stock}
                                                        onChange={(e) => {
                                                            const updated = [...variationsAccordion];
                                                            updated[index].stock = e.target.value;
                                                            setVariationsAccordion(updated);
                                                        }}
                                                    />
                                                </div>

                                                <div className="oms-form-group">
                                                    <label>Stock Status</label>
                                                    <Select
                                                        options={StockOptions}
                                                        value={variation.stockStatus}
                                                        onChange={(selected) => {
                                                            const updated = [...variationsAccordion];
                                                            updated[index].stockStatus = selected;
                                                            setVariationsAccordion(updated);
                                                        }}
                                                    />
                                                </div>

                                                <div className="oms-form-group">
                                                    <label>Single Image</label>
                                                    <button
                                                        type="button"
                                                        onClick={() => alert("Open single image uploader")}
                                                    >
                                                        Upload Image
                                                    </button>
                                                </div>

                                                <div className="oms-form-group">
                                                    <label>Gallery Images</label>
                                                    <button
                                                        type="button"
                                                        onClick={() => alert("Open gallery image uploader")}
                                                    >
                                                        Upload Gallery Images
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        )}




                        <div className="oms-form-group">
                            <label htmlFor="title" className="oms-form-label">
                                SKU No
                            </label>
                            <input
                                type="text"
                                id="title"
                                placeholder="Enter SKU No"
                                value={formData.title}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="oms-form-group">
                            <label htmlFor="category" className="oms-form-label">
                                Stock Status
                            </label>
                            <Select
                                options={StockOptions}
                                placeholder="Select Stock Status"
                                name="stock"
                                value={formData.stock}
                                onChange={handleSelectChange}
                            />
                        </div>

                        <div className="oms-form-group">
                            <label htmlFor="discountPrice" className="oms-form-label">
                                Total Stock
                            </label>
                            <input
                                type="number"
                                id="discountPrice"
                                placeholder="Enter Total Stock"
                                value={formData.discountPrice}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="discountPrice" className="oms-form-label">
                                Weight
                            </label>
                            <input
                                type="number"
                                id="discountPrice"
                                placeholder="Enter Weight"
                                value={formData.discountPrice}
                                onChange={handleChange}
                            />
                        </div>


                        <div className="oms-form-group">
                            <label className="oms-form-label">Dimensions (cm)</label>
                            <div className="oms-dimensions-row">
                                <input
                                    type="number"
                                    placeholder="Length"
                                    value={formData.length}
                                    onChange={(e) => setFormData({ ...formData, length: e.target.value })}
                                />
                                <input
                                    type="number"
                                    placeholder="Width"
                                    value={formData.width}
                                    onChange={(e) => setFormData({ ...formData, width: e.target.value })}
                                />
                                <input
                                    type="number"
                                    placeholder="Height"
                                    value={formData.height}
                                    onChange={(e) => setFormData({ ...formData, height: e.target.value })}
                                />
                            </div>
                        </div>

                        {/* Category */}
                        <div className="oms-form-group">
                            <label htmlFor="category" className="oms-form-label">
                                Category
                            </label>
                            <Select
                                options={categoryOptions}
                                placeholder="Select category"
                                name="category"
                                value={formData.category}
                                onChange={handleSelectChange}
                            />
                        </div>



                        {/* Status */}
                        <div className="oms-form-group">
                            <label htmlFor="status" className="oms-form-label">
                                Status
                            </label>
                            <Select
                                options={statusOptions}
                                placeholder="Select status"
                                name="status"
                                value={formData.status}
                                onChange={handleSelectChange}
                            />
                        </div>

                        {/* Actions */}
                        <div className="oms-form-actions">
                            <button type="button" onClick={() => setIsOpen(false)}>
                                Cancel
                            </button>
                            <button type="submit">Submit</button>
                        </div>
                    </form>
                </div>
            </div>

            {/* {isUploadModalOpen && (
                <UploadImageModal
                    isOpen={isUploadModalOpen}
                    setIsOpen={setUploadModalOpen}
                    setSelectedImages={(images) =>
                        setFormData((prev) => ({ ...prev, image: images }))
                    }
                />
            )} */}
        </>
    );
};

export default EquipmentsModal;


const UploadImageModal = ({ isOpen, setIsOpen, setSelectedImages }) => {
    const [uploadedImages, setUploadedImages] = useState([]);
    const [selectedImages, setSelected] = useState([]);

    if (!isOpen) return null;

    const handleFileChange = (event) => {
        const files = event.target.files;
        const fileArray = Array.from(files).map((file) => URL.createObjectURL(file));
        setUploadedImages((prev) => [...prev, ...fileArray]);
    };

    const openFileSelector = () => {
        document.getElementById("fileInput").click();
    };

    const handleImageClick = (image) => {
        setSelected((prev) =>
            prev.includes(image)
                ? prev.filter((img) => img !== image)
                : [...prev, image]
        );
    };

    const confirmSelection = () => {
        setSelectedImages(selectedImages); // Pass selected images to the parent component
        setIsOpen(false); // Close the modal
    };


    return (
        <>
            <div className="upload-modal-overlay" onClick={() => setIsOpen(false)}>
                <div
                    className="upload-modal-content"
                    onClick={(e) => e.stopPropagation()} // Prevent closing on content click
                >
                    {/* Close Button */}
                    <button className="upload-close-button" onClick={() => setIsOpen(false)}>
                        &times;
                    </button>

                    <div className="upload-imaage">
                        {/* Upload Image Container */}
                        <div
                            className="upload-image-list"
                            onClick={openFileSelector} // Trigger file selector
                        >
                            <div className="upload-image-container">
                                <p className="plus">+</p>
                                <p className="image-upload-text">Upload images</p>
                            </div>
                        </div>

                        {/* Hidden File Input */}
                        <input
                            type="file"
                            id="fileInput"
                            accept=".jpeg, .png, .webp"
                            multiple
                            style={{ display: "none" }}
                            onChange={handleFileChange}
                        />

                        {/* Uploaded Images */}
                        <div className="upload-image-list upload-img-list2">
                            {uploadedImages.map((image, index) => (
                                <div
                                    key={index}
                                    className={`uploaded-img ${selectedImages.includes(image) ? "selected" : ""
                                        }`}
                                    onClick={() => handleImageClick(image)}
                                >
                                    <img src={image} alt={`uploaded-${index}`} />
                                </div>
                            ))}
                        </div>

                        <button className="confirm-button" onClick={confirmSelection}>
                            Confirm Selection
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}


// EquipmentsModalUI.jsx
// import React, { useState } from 'react';
// import './EquipmentsModalUI.css';

const DownloadableFiles = () => {
    const [files, setFiles] = useState([{ name: '', url: '', file: null }]);
    const [showImageModal, setShowImageModal] = useState(false);
    const [images, setImages] = useState([]);

    const handleAddFile = () => {
        setFiles([...files, { name: '', url: '', file: null }]);
    };

    const handleRemoveFile = (index) => {
        const updatedFiles = files.filter((_, i) => i !== index);
        setFiles(updatedFiles);
    };

    const handleChange = (index, field, value) => {
        const updatedFiles = [...files];
        updatedFiles[index][field] = value;
        setFiles(updatedFiles);
    };

    return (
        <div className="downloadable-section">
            {/* <h4>Downloadable files</h4> */}
            <div className="file-input-table">
                {files.map((file, index) => (
                    <div className="file-row" key={index}>
                        <input
                            type="text"
                            placeholder="File name"
                            value={file.name}
                            onChange={(e) => handleChange(index, 'name', e.target.value)}
                        />
                        <input
                            type="text"
                            placeholder="http://"
                            value={file.url}
                            onChange={(e) => handleChange(index, 'url', e.target.value)}
                        />
                        <button
                            type="button"
                            onClick={() => setShowImageModal(true)}
                        >
                            Choose file
                        </button>
                        <input
                            id={`fileInput-${index}`}
                            type="file"
                            style={{ display: 'none' }}
                            onChange={(e) => handleChange(index, 'file', e.target.files[0])}
                        />
                        <button
                            type="button"
                            className="remove-btn"
                            onClick={() => handleRemoveFile(index)}
                        >
                            <i class="fa-solid fa-xmark"></i>
                        </button>
                        <ImageModalDownloadable
                            show={showImageModal}
                            handleClose={() => setShowImageModal(false)}
                            images={images}
                            // onImageSelect={(img) =>
                            //     setFormData((prev) => ({ ...prev, image: [img] }))
                            // }
                            multiple={false}
                            setImages={setImages}
                        />
                    </div>
                ))}
                <button className="add-btn" type="button" onClick={handleAddFile}>
                    Add File
                </button>
            </div>
        </div>
    );
};


